import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { Grid, Row, Col } from "react-flexbox-grid"
import { Logo, FacebookIcon, InstagramIcon, TwitterIcon, LinkedInIcon, LinkIcon} from '../Icons'
import { HomeURL, Language, Socials } from "../Tools"

import "./Header.scss"

const Header = ({ lang, socials }) => {
  const [ isSticky, setIsSticky ] = useState()

  const renderSocialIcon = (name) => {
    switch (name) {
      case Socials.Facebook:
        return <FacebookIcon className="header__icon" />
      case Socials.Insta:
        return <InstagramIcon className="header__icon" />
      case Socials.Twitter:
        return <TwitterIcon className="header__icon" />
      case Socials.LinkedIn:
        return <LinkedInIcon className="header__icon" />
      default:
        return <LinkIcon className="header__icon" />
    }
  }

  useEffect(() => {
    const toggleStickyMenu = () => {
      if (window.pageYOffset > 1) {
        setIsSticky(true)
      } else {
        setIsSticky(false)
      }
    }

    window.addEventListener("scroll", toggleStickyMenu)
    return () => window.removeEventListener("scroll", toggleStickyMenu)
  }, [])

  return (
    <header className={`header ${isSticky ? 'header--sticky' : ''}`}>
      <Grid>
        <Row middle="xs" between="xs">
          <Col xs={6}>
            <Link to={lang === Language.EN ? HomeURL.EN : HomeURL.FR}>
              <Logo className="header__logo" />
            </Link>
          </Col>
          <Col xs={6}>
            <div className="header__links">
              <Link className="header__lang" to={lang === Language.EN ? HomeURL.FR : HomeURL.EN}>
                {lang === Language.EN ? Language.FR : Language.EN}
              </Link>
              {!_.isEmpty(socials)? 
                socials.map((x, i) => 
                  <a key={i} className="header__social" href={x.link} target="_blank" rel="nofollow">
                    {renderSocialIcon(x.icon)}
                  </a>
                )
              : null}
            </div>
          </Col>
        </Row>
      </Grid>
    </header>
  )
}

Header.propTypes = {
  lang: PropTypes.oneOf([Language.EN, Language.FR]).isRequired,
  url: PropTypes.string.isRequired,
  socials: PropTypes.arrayOf(
    PropTypes.shape({ 
      icon: PropTypes.oneOf([
        Socials.Facebook, 
        Socials.Insta, 
        Socials.LinkedIn, 
        Socials.Twitter
      ]).isRequired, 
      link: PropTypes.string.isRequired
    })
  ),
}

Header.defaultProps = {
  lang: Language.EN,
  url: HomeURL.EN,
  socials: [
    {
      icon: Socials.Facebook,
      link: ''
    },
    {
      icon: Socials.Insta,
      link: ''
    }
  ]
}

export default Header